module.exports = __webpack_public_path__ + "static/template-team-member-3-d6a533074e8b8103b375a7b551d55c31.jpg";